// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isDeliverabilityPostmasterAppGroupIdDeliveryErrorsResult = objectOf({
  date: string,
  domain: string,
  delivery_error_type: string,
  delivery_error_class: string,
  error_ratio: string,
});
